// extracted by mini-css-extract-plugin
export default {"SupportButton":"SupportButton_SupportButton__lu69K","icon":"SupportButton_icon__lV6SC"};